import React, {useEffect, useState, useCallback} from "react";
import BasicModal from "../../Components/Modals/BasicModal";
import $ from 'jquery';
import {useNavigate, Link} from "react-router-dom";
import {useSelector} from "react-redux";
import swal from 'sweetalert';
import axios from "axios";
import _ from "lodash";
import "../../assets/css/pages/brands.css";
import noImage from "../../assets/media/svg/no-image.svg";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const [bulkArray, setBulkArray] = useState([]);
  const buttonIsDisabled = !bulkArray.length;

  const [idFilter, setIdFilter] = useState(null);
  const [nameFilter, setNameFilter] = useState(null);

  const deleteRow = (table, selector) => {
    table
      .row(selector.parents('tr'))
      .remove()
      .draw(false);
  }

  useEffect(() => {
    triggerDatatable();
  }, []);

  const triggerFilter = (e) => {
    e.preventDefault();
    localStorage.removeItem("DataTables_brands_/brands");
    triggerDatatable();
  }

  const triggerDatatable = () => {
    let table = $('#brands').DataTable({
      "ajax": {
        url: process.env.REACT_APP_API_URL + "brands",
        method: 'GET',
        data: {
          id: idFilter,
          name: nameFilter,
        },
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      "destroy": true,
      "columns": [
        {
          data: 'checkbox',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <label class="form-label-checkbox fs-6 fw-bolder text-dark">
                      <input class="checkbox list" type="checkbox" label="My Value" name="primary" row-id="${row.id}">
                      <span class="checkmark"></span>
                    </label>`;
          },
        },
        {data: 'id', name: 'id'},
        {data: 'name', name: 'name'},
        {
          data: 'description',
          name: 'description',
          orderable: false,
          render: function (data, type, row) {
            return `<div class="ellipsis">${row?.description}</div>`
          }

        },
        {
          data: 'image',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            let img = noImage;
            if (row?.media?.[0]?.collection_name == "logo") {
              img = row?.media?.[0]?.original_url
            }
            return `<div class="image${img == noImage ? ' no-image' : ''}">
            <img
                class="w-100${img == noImage ? ' opacity-25' : ''}"
                row-id="${row.id}" src="${img}"/>
                </div>`;
          },
        },
        {
          data: 'actions',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                            <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>
                    `;
          },
        }
      ],
      "order": [[0, "desc"]],
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      if ($(this).next(".row-actions").hasClass("hidden-actions")) {
        $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
      } else {
        $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
      }
    });

    table.on('click', 'button.delete', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      $(".row-actions").fadeOut(100).addClass("hidden-actions");
      deleteBrand(id, name, table, $(this));
    });

    table.on('click', 'button.edit', function () {
      const id = ($(this).attr("row-id"));
      navigate('/brands/' + id + '/edit');
    });

    $("<span class='table-filter-icon br-0-95-rem' title='Filter'><i class='fa fa-filter fs-4 br-1000'></i>Filter</span>")
      .insertAfter("#brands_length label");

    $(".table-filter-icon").click(function () {
      $(".toggle-filter").slideToggle(100);

      let condition = $(".table-filter-icon i").hasClass("fa-filter");

      $(".table-filter-icon")
        .html(condition ? "<i class='far fa-times-circle fs-4 br-1000'></i>Close"
          : "<i class='fa fa-filter fs-4 br-1000'></i>Filter");
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

    table.on('click', '.form-label-checkbox .checkbox', function () {
      const id = ($(this).attr("row-id"));
      setBulkArray(cur => _.xor(cur, [id]));
    });

    $('.toggle-filter').each(function () {
      if ($(this).css('display') == 'block') {
        $(".table-filter-icon").html("<i class='far fa-times-circle fs-4 br-1000'></i>Close");
      }
    });

    table.on('click', '.form-label-checkbox .checkbox.mark-all', function () {
      if ($(this).is(':checked')) {
        setBulkArray([]);
        let allId = [];
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == false) {
            $(this).click();
          }
          allId.push($(this).attr("row-id"));
        });
        setBulkArray(allId);
      } else {
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == true) {
            $(this).click();
          }
        });
        setBulkArray([]);
      }
    });

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
        resetMarked();
      });
      resetMarked();
      $(".form-label-checkbox #mark-all").click().click();
    });

    $("table.dataTable thead tr:first-child th:nth-child(1)")
      .html(`<label class="form-label-checkbox form-label-checkbox-mark-all  fs-6 fw-bolder text-dark pt-0">
           <input class="checkbox mark-all" type="checkbox" id="mark-all" label="My Value" name="primary">
           <span class="checkmark"><span></span></span>
           </label>`);

  }

  const resetMarked = () => {
    if ($(".form-label-checkbox .checkbox.mark-all").is(":checked")) {
      $(".form-label-checkbox .checkbox.mark-all").click();
    }
    $(".form-label-checkbox .checkbox.list").each(function (index) {
      if ($(this).is(':checked') == true) {
        $(this).click();
      }
    });
    setBulkArray([]);
  }

  const deleteBrand = (id, name, table, selector) => {
    swal({
      title: "Are you sure?",
      text: 'You want to delete brand "' + name + '"?',
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.delete('brands/' + id, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        }).then(function (res) {
          if (res.status == 200 && res.data?.status) {
            swal('The brand "' + name + '" has been deleted!', {
              icon: "success",
            });
            deleteRow(table, selector);
            return true;
          } else {
            return false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  const bulkDeleteBrand = () => {
    swal({
      title: "Are you sure?",
      text: `You want to delete marked brands?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      console.log(result);
      if (result == true) {
        axios.post('brands/bulk-destroy', {
          brands: bulkArray,
        })
          .then(function (res) {
            if (res.status == 200 && res.data?.status) {
              swal(`Brands has been deleted successfully!`, {
                icon: "success",
              });

              resetMarked();
              $('#brands').DataTable().draw(false);
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data.errors);
            }
          });
      }
    });
  }

  return (
    <>
      <div>
        <div className="toggle-filter display-none">
          <form onSubmit={triggerFilter} className="row">

            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">ID</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="id"
                     onChange={(e) => {
                       setIdFilter(e.target.value)
                     }}
                     value={idFilter}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-4 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Name</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="first_name"
                     onChange={(e) => {
                       setNameFilter(e.target.value)
                     }}
                     value={nameFilter}
              />
            </div>

            <div className="col-xxl-6 col-lg-12 text-xxl-end pt-7">
              <button
                className="btn btn-primary"
                title="Filter Table"
                type="submit"
                onClick={triggerFilter}
              >
                <i className="fas fa-sync-alt fs-5 mr-2"></i>
                Filter
              </button>
            </div>
          </form>
        </div>
        <div className="text-right pb-3">
          <div className={`marked-actions d-inline-block ${buttonIsDisabled ? " d-none" : ""}`}>
            <span className="d-inline-block border-end pr-3 mr-3">
              <button
                type="button"
                className="btn btn-danger br-12-5-px w-10-rem"
                onClick={() => bulkDeleteBrand()}
                disabled={buttonIsDisabled}
              >
                <i className="far fa-trash-alt fs-5 mr-2"></i> Delete
              </button>
            </span>
          </div>
          <button type="button"
                  className="btn btn-primary br-12-5-px mr-3"
                  data-bs-toggle="tooltip"
                  title="Coming Soon"
                  onClick={() => {
                    navigate('/brands/create');
                  }}
          >
            <i className="fas fa-plus-circle fs-5 mr-2"></i>
            Add Brand
          </button>
        </div>
        <table id="brands" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
          <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th></th>
            <th>ID</th>
            <th>Name</th>
            <th>Description</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold"></tbody>
        </table>
      </div>
    </>
  );
}